export default __webpack_public_path__ + "static/media/H1001a.eb16f512.mp3";